import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MIDirectivesModule } from 'src/app/directives/directives.module';
import { AuthUIServiceInterface, AUTH_UI_SERVICE } from 'src/app/services/auth/auth-ui.service.interface';
import { ActionSource } from 'src/app/services/yeti-protocol/tracking';
import { AuthButtonsComponent } from '../auth-buttons/auth-buttons.component';

@Component({
  selector: 'app-auth-welcome-small-screen',
  templateUrl: './auth-welcome-small-screen.component.html',
  styleUrls: ['./auth-welcome-small-screen.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MIDirectivesModule,
    AuthButtonsComponent
  ]
})
export class AuthWelcomeSmallScreenComponent {

  @Input() source : ActionSource = ActionSource.unspecified;

  constructor(
    @Inject(AUTH_UI_SERVICE) private authUIService: AuthUIServiceInterface
  ) { }

  onOpenAbout(): void {
    this.authUIService.closeDialog('/about');
  }
}
